import { render } from "./ProyectoEstatusList.vue?vue&type=template&id=99700e08&scoped=true"
import script from "./ProyectoEstatusList.vue?vue&type=script&lang=js"
export * from "./ProyectoEstatusList.vue?vue&type=script&lang=js"

import "./ProyectoEstatusList.vue?vue&type=style&index=0&id=99700e08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99700e08"]])

export default __exports__